<template>
  <v-card v-if="allDone" flat class="mx-auto mt-5" max-width="500">
    <v-card-title class="accent">
      <v-spacer />
      <span class="white--text">Zhrnutie objednávky</span>
      <v-spacer />
    </v-card-title>
    <v-list>
      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-email</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ orderInfo.userInfo.email }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-map-marker</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title
            >{{ orderInfo.building }} {{ orderInfo.block }} -
            {{ orderInfo.flatId }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-clock</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title
            >{{ this.getEuroDate(orderInfo.date) }},
            {{ orderInfo.term }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-account</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title
            >{{ orderInfo.choosePerson.name }}
            {{ orderInfo.choosePerson.surname }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-broom</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ orderInfo.cleaningType }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-action>
          <v-icon>mdi-currency-eur</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title
            >{{ orderInfo.choosePerson.price }} &euro;/hod</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item v-if="orderInfo.userInfo.note">
        <v-list-item-action>
          <v-icon>mdi-comment-outline</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ orderInfo.userInfo.note }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>
    </v-list>
    <v-checkbox
      :rules="rule"
      v-model="agreement"
      color="accent"
      class="px-3 mb-5"
      label="Záväzne potvrdzujem svoju objednávku a súhlasím s povinnosťou platby v hotovosti upratovačovi"
    >
    </v-checkbox>

    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="orderCompleted">
        Potvrdiť objednávku
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import * as axios from "axios";
import store from "../../store/store";
export default {
  name: "OrderConfirmation",
  data: () => ({
    reveal: false,
    agreement: false,
    rule: [v => v || "Musíte akceptovať podmienky"]
  }),
  methods: {
    getEuroDate(date) {
      var myDate = new Date(date);
      return (
        ("0" + myDate.getDate()).slice(-2) + "." + ("0" + (myDate.getMonth() + 1)).slice(-2)  + "." + myDate.getFullYear()
      );
    },
    makeCode(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    orderCompleted() {
      if (this.refForm.validate()) {
        let code = "#" + this.makeCode(5)
        localStorage.setItem("code", code)
        let jsonOrder = { code }
  
        let orders = localStorage.getItem("orders")
        if(!orders) {
          orders = {}
        }
        else {
          orders = JSON.parse(orders)
        }
        orders[code] = jsonOrder;
        localStorage.setItem("orders", JSON.stringify(orders))
        const params = new URLSearchParams();
        params.append("code", code)
        params.append("customer_email", this.orderInfo.userInfo.email);
        params.append("date", this.getEuroDate(this.orderInfo.date));
        params.append("building", this.orderInfo.building);
        params.append("block", this.orderInfo.block);
        params.append("flat", this.orderInfo.flatId);
        params.append("cleaning_type", this.orderInfo.cleaningType);
        params.append("state", "nová");
        params.append("user_id", this.orderInfo.choosePerson.id);
        params.append("note", this.orderInfo.userInfo.note)
        params.append("term", this.orderInfo.term);
        axios({
          method: "post",
          url: store.state.url.concat("orderCompleted.php"),
          data: params,
        }).then(
            response => {
              if (response.data.result == true){
                this.$router.push({name: "orderCompleted"});
              }
            },
            error => {
              console.log(error);
            }
        )
        this.$router.push("orderCompleted")
      }
    }
  },
  props: ["orderInfo", "allDone", "refForm"]
};
</script>
